import { $t } from '@teachino/shared-i18n';

export class KeyboardShortcut {
  private readonly modMac = $t('keyboard.modifier.mac');
  private readonly modWindows = $t('keyboard.modifier.windows');
  private readonly shift = $t('keyboard.shift');
  constructor(
    private args: { useModifier: boolean; useShift: boolean; key?: string },
  ) {}

  get(): string {
    return this.parts().join('+');
  }

  parts(): string[] {
    const { useShift, useModifier, key } = this.args;

    const parts: string[] = [];

    if (useModifier) {
      if (navigator.userAgent.includes('Mac')) {
        parts.push(this.modMac);
      } else {
        parts.push(this.modWindows);
      }
    }
    if (useShift) {
      parts.push(this.shift);
    }
    if (key) {
      parts.push(key);
    }
    return parts;
  }
}
